import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _62d6c9c6 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _56a887d6 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _cc4543c0 = () => interopDefault(import('..\\pages\\path.vue' /* webpackChunkName: "pages_path" */))
const _5488c62d = () => interopDefault(import('..\\pages\\patient-is.vue' /* webpackChunkName: "pages_patient-is" */))
const _63c0812c = () => interopDefault(import('..\\pages\\patient-needs.vue' /* webpackChunkName: "pages_patient-needs" */))
const _402f4d79 = () => interopDefault(import('..\\pages\\quickBi\\index.vue' /* webpackChunkName: "pages_quickBi_index" */))
const _733ce61e = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _71df44ff = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _54167abb = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _01176444 = () => interopDefault(import('..\\pages\\bi\\assessment.vue' /* webpackChunkName: "pages_bi_assessment" */))
const _21eccd9e = () => interopDefault(import('..\\pages\\bi\\assessment2.vue' /* webpackChunkName: "pages_bi_assessment2" */))
const _ddfca2a2 = () => interopDefault(import('..\\pages\\bi\\cargiver.vue' /* webpackChunkName: "pages_bi_cargiver" */))
const _81aca842 = () => interopDefault(import('..\\pages\\bi\\diagnosis.vue' /* webpackChunkName: "pages_bi_diagnosis" */))
const _db814e0a = () => interopDefault(import('..\\pages\\bi\\eligibility.vue' /* webpackChunkName: "pages_bi_eligibility" */))
const _5b83fab2 = () => interopDefault(import('..\\pages\\bi\\insurance-information.vue' /* webpackChunkName: "pages_bi_insurance-information" */))
const _94dde35c = () => interopDefault(import('..\\pages\\bi\\patient-information.vue' /* webpackChunkName: "pages_bi_patient-information" */))
const _ec3136ec = () => interopDefault(import('..\\pages\\bi\\patient-pharmacy-insurance.vue' /* webpackChunkName: "pages_bi_patient-pharmacy-insurance" */))
const _28159267 = () => interopDefault(import('..\\pages\\bi\\patient-secondary-insurance.vue' /* webpackChunkName: "pages_bi_patient-secondary-insurance" */))
const _3415d6bd = () => interopDefault(import('..\\pages\\bi\\pre-authorization.vue' /* webpackChunkName: "pages_bi_pre-authorization" */))
const _85dbd9c8 = () => interopDefault(import('..\\pages\\bi\\prescription.vue' /* webpackChunkName: "pages_bi_prescription" */))
const _048debf3 = () => interopDefault(import('..\\pages\\bi\\secondary-medical-insurance.vue' /* webpackChunkName: "pages_bi_secondary-medical-insurance" */))
const _1b091178 = () => interopDefault(import('..\\pages\\bi\\select-path.vue' /* webpackChunkName: "pages_bi_select-path" */))
const _22a90260 = () => interopDefault(import('..\\pages\\bi\\services.vue' /* webpackChunkName: "pages_bi_services" */))
const _9689b51e = () => interopDefault(import('..\\pages\\bi\\success.vue' /* webpackChunkName: "pages_bi_success" */))
const _8d8bf8d8 = () => interopDefault(import('..\\pages\\bi\\summary.vue' /* webpackChunkName: "pages_bi_summary" */))
const _68137004 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _67f74102 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _67bee2fe = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _67a2b3fc = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _00dc833f = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _cc6abcba = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _968c5254 = () => interopDefault(import('..\\pages\\quickBi\\cargiver.vue' /* webpackChunkName: "pages_quickBi_cargiver" */))
const _03aa59ed = () => interopDefault(import('..\\pages\\quickBi\\enrollment.vue' /* webpackChunkName: "pages_quickBi_enrollment" */))
const _ec5edc40 = () => interopDefault(import('..\\pages\\quickBi\\insurance-information.vue' /* webpackChunkName: "pages_quickBi_insurance-information" */))
const _7cc017cb = () => interopDefault(import('..\\pages\\quickBi\\patient-information.vue' /* webpackChunkName: "pages_quickBi_patient-information" */))
const _23da70f1 = () => interopDefault(import('..\\pages\\quickBi\\patient-pharmacy-insurance.vue' /* webpackChunkName: "pages_quickBi_patient-pharmacy-insurance" */))
const _66f7da40 = () => interopDefault(import('..\\pages\\quickBi\\patient-secondary-insurance.vue' /* webpackChunkName: "pages_quickBi_patient-secondary-insurance" */))
const _703aea76 = () => interopDefault(import('..\\pages\\quickBi\\pre-authorization.vue' /* webpackChunkName: "pages_quickBi_pre-authorization" */))
const _7a9bcfc3 = () => interopDefault(import('..\\pages\\quickBi\\prescription.vue' /* webpackChunkName: "pages_quickBi_prescription" */))
const _ae072728 = () => interopDefault(import('..\\pages\\quickBi\\secondary-medical-insurance.vue' /* webpackChunkName: "pages_quickBi_secondary-medical-insurance" */))
const _d64c472c = () => interopDefault(import('..\\pages\\quickBi\\success.vue' /* webpackChunkName: "pages_quickBi_success" */))
const _cd4e8ae6 = () => interopDefault(import('..\\pages\\quickBi\\summary.vue' /* webpackChunkName: "pages_quickBi_summary" */))
const _ea630632 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _62d6c9c6,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _56a887d6,
    name: "have-a-card"
  }, {
    path: "/path",
    component: _cc4543c0,
    name: "path"
  }, {
    path: "/patient-is",
    component: _5488c62d,
    name: "patient-is"
  }, {
    path: "/patient-needs",
    component: _63c0812c,
    name: "patient-needs"
  }, {
    path: "/quickBi",
    component: _402f4d79,
    name: "quickBi"
  }, {
    path: "/rejection",
    component: _733ce61e,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _71df44ff,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _54167abb,
    name: "upload-documents"
  }, {
    path: "/bi/assessment",
    component: _01176444,
    name: "bi-assessment"
  }, {
    path: "/bi/assessment2",
    component: _21eccd9e,
    name: "bi-assessment2"
  }, {
    path: "/bi/cargiver",
    component: _ddfca2a2,
    name: "bi-cargiver"
  }, {
    path: "/bi/diagnosis",
    component: _81aca842,
    name: "bi-diagnosis"
  }, {
    path: "/bi/eligibility",
    component: _db814e0a,
    name: "bi-eligibility"
  }, {
    path: "/bi/insurance-information",
    component: _5b83fab2,
    name: "bi-insurance-information"
  }, {
    path: "/bi/patient-information",
    component: _94dde35c,
    name: "bi-patient-information"
  }, {
    path: "/bi/patient-pharmacy-insurance",
    component: _ec3136ec,
    name: "bi-patient-pharmacy-insurance"
  }, {
    path: "/bi/patient-secondary-insurance",
    component: _28159267,
    name: "bi-patient-secondary-insurance"
  }, {
    path: "/bi/pre-authorization",
    component: _3415d6bd,
    name: "bi-pre-authorization"
  }, {
    path: "/bi/prescription",
    component: _85dbd9c8,
    name: "bi-prescription"
  }, {
    path: "/bi/secondary-medical-insurance",
    component: _048debf3,
    name: "bi-secondary-medical-insurance"
  }, {
    path: "/bi/select-path",
    component: _1b091178,
    name: "bi-select-path"
  }, {
    path: "/bi/services",
    component: _22a90260,
    name: "bi-services"
  }, {
    path: "/bi/success",
    component: _9689b51e,
    name: "bi-success"
  }, {
    path: "/bi/summary",
    component: _8d8bf8d8,
    name: "bi-summary"
  }, {
    path: "/errors/400",
    component: _68137004,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _67f74102,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _67bee2fe,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _67a2b3fc,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _00dc833f,
    name: "errors-500"
  }, {
    path: "/patient/patientSearch",
    component: _cc6abcba,
    name: "patient-patientSearch"
  }, {
    path: "/quickBi/cargiver",
    component: _968c5254,
    name: "quickBi-cargiver"
  }, {
    path: "/quickBi/enrollment",
    component: _03aa59ed,
    name: "quickBi-enrollment"
  }, {
    path: "/quickBi/insurance-information",
    component: _ec5edc40,
    name: "quickBi-insurance-information"
  }, {
    path: "/quickBi/patient-information",
    component: _7cc017cb,
    name: "quickBi-patient-information"
  }, {
    path: "/quickBi/patient-pharmacy-insurance",
    component: _23da70f1,
    name: "quickBi-patient-pharmacy-insurance"
  }, {
    path: "/quickBi/patient-secondary-insurance",
    component: _66f7da40,
    name: "quickBi-patient-secondary-insurance"
  }, {
    path: "/quickBi/pre-authorization",
    component: _703aea76,
    name: "quickBi-pre-authorization"
  }, {
    path: "/quickBi/prescription",
    component: _7a9bcfc3,
    name: "quickBi-prescription"
  }, {
    path: "/quickBi/secondary-medical-insurance",
    component: _ae072728,
    name: "quickBi-secondary-medical-insurance"
  }, {
    path: "/quickBi/success",
    component: _d64c472c,
    name: "quickBi-success"
  }, {
    path: "/quickBi/summary",
    component: _cd4e8ae6,
    name: "quickBi-summary"
  }, {
    path: "/",
    component: _ea630632,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
